// removed by extract-text-webpack-plugin
module.exports = {"section":"src-templates----legal-module---section---310Rd"};


//////////////////
// WEBPACK FOOTER
// ./src/templates/legal.module.scss
// module id = 572
// module chunks = 225142215220636